import { render, staticRenderFns } from "./SectionLabel.vue?vue&type=template&id=847823f4&"
import script from "./SectionLabel.vue?vue&type=script&lang=js&"
export * from "./SectionLabel.vue?vue&type=script&lang=js&"
import style0 from "./SectionLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports